import React, { useEffect, useState } from 'react';
import { Box, TextField, withStyles } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import ReportApi from '../../../api/ReportApi';
import { filters } from './styles';

function StaffsFilter({ classes, label, handleFilterChange, filters }) {
    const [items, setItems] = useState([]);
    const [selectedItems, setSelectedItems] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const fetch = async () => {
            setLoading(true);

            const staffs = await ReportApi.getStaffs();

            setItems(
                staffs.map(staff => ({
                    label: staff.displayName,
                    value: staff.id
                }))
            );

            setLoading(false);
        };

        fetch();
    }, []);

    useEffect(() => {
        if (items.length > 0) {
            const value = filters['soldBy'];
            if (value) {
                setSelectedItems(value.map(sv => items.find(s => s.value === sv.value)));
            }
        }
    }, [filters, items]);

    const handleChange = (_, items) => {
        handleFilterChange({
            soldBy: items
        });
        setSelectedItems(items);
    };

    return (
        <Box marginTop={4}>
            <Autocomplete
                multiple
                className={classes.autocomplete}
                options={items}
                value={selectedItems}
                onChange={handleChange}
                loading={loading}
                label={label}
                getOptionLabel={option => option.label}
                renderInput={params => (
                    <TextField
                        {...params}
                        label={label}
                        variant="outlined"
                        InputProps={{
                            ...params.InputProps,
                            classes: {
                                input: classes.autocompleteInputProps
                            }
                        }}
                        InputLabelProps={{
                            ...params.InputLabelProps,
                            className: classes.autocompleteLabelProps
                        }}
                    />
                )}
                renderOption={option => {
                    return <p className={classes.autocompleteOptions}>{`${option.label}`}</p>;
                }}
                ChipProps={{ className: classes.autocompleteChipProps }}
            />
        </Box>
    );
}

export default withStyles(filters)(StaffsFilter);
